<template>
    <v-card elevation="2" max-width="900" class="mb-4 pa-4">
        <v-row dense>
            <v-col v-for="detail in details" :key="detail.label" cols="12" sm="6">
                <div class="d-flex align-baseline">
                    <strong class="detail-label">{{ detail.label }}:</strong>
                    <span class="detail-value">{{ detail.value }}</span>
                </div>
            </v-col>
        </v-row>
    </v-card>

    <v-card elevation="2" max-width="900" class="d-flex flex-column" height="100%">
        <v-card-title class="text-h6 font-weight-bold text-left">
            Conversation Transcript
        </v-card-title>
        <v-divider />
        <v-container class="chat-body">
            <div v-if="loading">Loading transcript...</div>
            <div v-else-if="error" class="text-error">{{ error }}</div>
            <div v-else>
                <div v-for="(entry, index) in flatMessages" :key="index" class="mb-4">
                    <div class="text-caption text-grey mb-1 text-left">{{ formatDate(entry.timestamp) }}</div>

                    <div class="d-flex align-end" :class="entry.sender === 'bot' ? 'justify-start' : 'justify-end'">
                        <template v-if="entry.sender === 'bot'">
                            <v-avatar size="24" class="mr-2">
                                <v-icon>mdi-robot-outline</v-icon>
                            </v-avatar>
                            <v-card color="amber-lighten-5" class="pa-3 rounded-lg text-left" max-width="75%">
                                {{ entry.text }}
                            </v-card>
                        </template>

                        <template v-else>
                            <v-card color="grey-lighten-3" class="pa-3 rounded-lg text-left" max-width="75%">
                                {{ entry.text }}
                            </v-card>
                            <v-avatar size="24" class="ml-2">
                                <v-icon>mdi-account-outline</v-icon>
                            </v-avatar>
                        </template>
                    </div>
                </div>
            </div>
        </v-container>
    </v-card>
</template>


<script setup>
import { ref, onMounted, computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

// If customer is not selected, go to dashboard
if (!localStorage.getItem('customerGUID')) {
    this.$router.push('/partner/dashboard');
}
// If bot is not selected go to customer
const botId = localStorage.getItem("botID") || '';
if (!botId) {
    this.$router.push('/partner/customer');
}

const callId = route.query.call_id

const callInfo = ref({ id: callId, date: '', duration: '', interactionCount: 0 })
const flatMessages = ref([])
const loading = ref(true)
const error = ref(null)

const details = computed(() => [
    { label: 'Conversation ID', value: callInfo.value.id },
    { label: 'Start Time', value: callInfo.value.date },
    { label: 'Duration', value: callInfo.value.duration },
    { label: 'Channel', value: 'AUDIO' },
    { label: 'Interaction Count', value: callInfo.value.interactionCount }
]);

onMounted(async () => {

    try {
        const response = await fetch(process.env.VUE_APP_VORTEX_PORTAL_WS + `/bots/${botId}/calls/${callId}/transcript`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                //Authorization: `Bearer ${token}`,
            }
        });

        const data = await response.json();

        const dialog = data?.data?.transcript?.dialog || []
        if (!dialog.length) {
            console.warn('[Empty Dialog]')
            flatMessages.value = []
        } else {
            const messages = []

            dialog.forEach(entry => {
                if (entry.agentUtterance) {
                    messages.push({
                        text: entry.agentUtterance.trim(),
                        timestamp: entry.timestamp,
                        sender: 'bot'
                    })
                }

                if (entry.userUtterance) {
                    messages.push({
                        text: entry.userUtterance.trim(),
                        timestamp: entry.timestamp,
                        sender: 'user'
                    })
                }
            })

            flatMessages.value = messages

            callInfo.value.date = new Date(dialog[0].timestamp).toLocaleDateString()
            callInfo.value.duration = `${dialog.length * 4}s`
            callInfo.value.interactionCount = flatMessages.value.length

        }
    } catch (err) {
        console.error('[API Error]', err)
        error.value = 'Failed to fetch transcript data.'
    } finally {
        loading.value = false
    }
})

function formatDate(dateStr) {
    return new Date(dateStr).toLocaleTimeString()
}
</script>

<style scoped>
.chat-body::-webkit-scrollbar {
    width: 6px;
}

.chat-body::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 4px;
}

.detail-label {
    width: 160px;
    flex-shrink: 0;
    font-weight: 600;
    color: #616161;
    /* grey-darken-1 */
}

.detail-value {
    color: #212121;
    /* grey-darken-4 */
}
</style>
